/* eslint-disable no-unused-expressions */
import React, { Component } from "react";
import { connect } from "react-redux";
import ScLayoutTab from "../components/layout/scLayoutTab";
import Tool from "../utils/Tool";
@connect((state) => state)
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuList: [],
    };
  }

  componentWillMount() {
    // 本地服务调试请直接设置token
    this.setUserInfoByDev();
  }

  setUserInfoByDev() {
    process.env.doingType === "start" &&
      window.sessionStorage.setItem("token", Tool.getUrlParam("token"));
    process.env.doingType === "start" &&
      window.sessionStorage.setItem("name", Tool.getUrlParam("name"));
    process.env.doingType === "start" &&
      window.sessionStorage.setItem("userId", Tool.getUrlParam("id"));
  }

  render() {
    return (
      <div>
        <ScLayoutTab />
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/AntD/pages/index.js